import { render, staticRenderFns } from "./TipoIcon.vue?vue&type=template&id=7aa96d96&"
import script from "./TipoIcon.vue?vue&type=script&lang=js&"
export * from "./TipoIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports